import React, { useEffect } from 'react';

const CSSLoader = () => {
  useEffect(() => {
    // Load CSS files dynamically with proper base URL
    const loadCSS = (href) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = process.env.PUBLIC_URL + href;
      document.head.appendChild(link);
    };

    // Load all CSS files with proper paths
    const cssFiles = [
      '/css/bootstrap.min.css',
      '/css/animate.min.css',
      '/css/magnific-popup.css',
      '/css/fontawesome-all.min.css',
      '/css/owl.carousel.min.css',
      '/css/nice-select.css',
      '/css/flaticon.css',
      '/css/jquery-ui.css',
      '/css/slick.css',
      '/css/default.css',
      '/css/style.css',
      '/css/responsive.css'
    ];

    cssFiles.forEach(loadCSS);

    // Cleanup function
    return () => {
      // Remove the dynamically added CSS files when component unmounts
      const links = document.head.querySelectorAll('link[rel="stylesheet"]');
      links.forEach(link => {
        if (cssFiles.some(file => link.href.includes(file))) {
          document.head.removeChild(link);
        }
      });
    };
  }, []);

  return null;
};

export default CSSLoader;